// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7427cced","732":"d6935204","977":"13cb922d"}[chunkId] + ".chunk.js";
};